let React          = require("react");
let DataListPage   = require("../../pages/generic/DataListPage.jsx");
let EmptyTrashCard = require("../empty/EmptyTrashCard.jsx");
let TrashCard      = require("../cards/TrashCard.jsx");

class TrashHub extends React.Component {

    shouldComponentUpdate(nextProps){
        return  Number(this.props.hub.id) !== Number(nextProps.hub.id) ||
                Boolean(this.props.hub.deleted) !== Boolean(nextProps.hub.deleted)
    }

    render() {
        const hubDeleted = Boolean(this.props.hub.deleted);
        const WrappedTrashCard = porps => <TrashCard {...porps} hubDeleted={hubDeleted}/>;

        return  <DataListPage
                    {...this.props}
                    cssCardTag="package"
                    urlName="trash"
                    displayName={`Items Deleted from "${this.props.hub.name}"`}
                    endpoint="/trash/search?"
                    filtersEndpoint={{hub: this.props.hub.id}}
                    loginRequired
                    canSwitchLayout
                    EmptyCard={EmptyTrashCard}
                    CardType={WrappedTrashCard}
                    isTrash
                />
    }
}

module.exports = TrashHub;
